import React, { useEffect, useState } from 'react'
import { withRouter, Link, NavLink, useHistory } from 'react-router-dom'
import { Container, Nav, Navbar } from 'react-bootstrap'
import { Avatar, Popover, Badge, Divider, Spin, message } from 'antd'
import logo from '../../../assets/images/LogoExitFundMobile.svg'
import logoExitFund from '../../../assets/images/LogoExitFund.svg'
import './InvestorDeals.scss'
import ProfileIcon from '../../../assets/images/Icons/ProfileIcon'
import EducationIcon from '../../../assets/images/Icons/EducationIcon'
import ScoutDashboardIcon from '../../../assets/images/Icons/ScoutDashboardIcon'
import CrownIcon from '../../../assets/images/Icons/CrownIcon'
import SettingsIcon from '../../../assets/images/Icons/SettingsIcon'
import copyClipboard from '../../../assets/images/scouts/copyClipboard.svg'
import LogoutIcon from '../../../assets/images/Icons/LogoutIcon'
import GroupAffiliationIcon from '../../../assets/images/Icons/GroupAffiliationIcon'
import {
  getNotificationDropdownData,
  getNotificationData,
  fetchInvestorKarmaPoints,
  clearInvestorNotification,
  portalRedirection,
} from '../../../redux/investorFlowControl/investorFlowControlActions'
import { connect } from 'react-redux'
import NotificationNotFoundIcon from '../../../assets/images/Icons/NotificationNotFoundIcon'
import {
  fetchInvestorUserLogout,
  logoutLocalInvestorUser,
  updateLocalStartupUser,
} from '../../../redux/auth/authActions'
import KarmaStarIcon from '../../../assets/images/Icons/KarmaStartIcon'
import NotificationIcon from '../../../assets/images/Icons/NotificationIcon'
import NotificationItem from './PassDealSteps/components/NotificationItem'
import CopyToClipboard from 'react-copy-to-clipboard'

const InvestorHeader = ({
  getNotificationDropdownData,
  clearInvestorNotification,
  logoutLocalInvestorUser,
  portalRedirection,
  user,
  notificationCall = true,
  investorKarmaPoints,
  fetchInvestorUserLogout,
  setIsLoggingOut = () => {},
}) => {
  // Define all the states
  const history = useHistory()
  const [open, setOpen] = useState(false)
  const [openKarma, setOpenKarma] = useState(false)
  const [openNotification, setOpenNotification] = useState(null)
  const [count, setCount] = useState(0)
  const [notificationData, setNotificationData] = useState([])
  const [loader, setLoader] = useState(false)
  const [logoutLoader, setLogoutLoader] = useState(false)
  // Hit the api to get the notifications data count
  useEffect(() => {
    if (notificationCall) {
      getNotificationDropdownData(false).then(res => {
        if (res.result) {
          setCount(res.count)
        }
      })
    }
  }, [])

  useEffect(() => {
    if (
      history.location.pathname !== '/investor/another-investment' &&
      localStorage.getItem('new_bank_added')
    ) {
      localStorage.removeItem('new_bank_added')
    }
  }, [])

  // Hit the api to get the notifications data
  useEffect(() => {
    if (openNotification) {
      setLoader(true)
      getNotificationDropdownData(true).then(res => {
        if (res.result) {
          setNotificationData(res.data)
          setLoader(false)
        }
      })
    } else if (openNotification !== null) {
      setCount(0)
    }
  }, [openNotification])

  // Hit the function when user click on profile menus
  const onItemClick = url => {
    history.push(url)
    setOpen(false)
  }

  // Hit the function to clear the notifications
  const onClearNotify = () => {
    clearInvestorNotification().then(res => {
      setNotificationData([])
    })
  }
  // render the profile popover
  const renderProfileContent = () => {
    return (
      <div className="profilePopupCon">
        <div className="itemPopup" onClick={() => onItemClick('/investor/profile')}>
          <ProfileIcon />
          Profile
        </div>
        {/* <div className="itemPopup" onClick={() => onItemClick('/investor/premium-plans')}>
          <CrownIcon />
          Premium Plans
        </div> */}
        <div
          className="itemPopup itemPopup-edu"
          onClick={() => {
            portalRedirection('investor', 'education')
              .then(res => {
                if (res.result) {
                  localStorage.setItem('learnInvest_token', res.token)
                  localStorage.setItem('login_type', res.user.login_type)
                  localStorage.setItem('startup_account', res.user.startup_account)
                  window.open('/education/learn-invest/syllabus', '_blank')
                } else {
                  if (res.error === 'user is paused') {
                    window.open('/suspend', '_blank')
                  }
                }
              })
              .catch(err => {
                if (err?.error === 'user is paused') {
                  window.open('/suspend', '_blank')
                }
              })
          }}
        >
          <EducationIcon />
          Education
        </div>
        <div
          className="itemPopup"
          onClick={() => {
            portalRedirection('investor', 'scout')
              .then(res => {
                if (res.result) {
                  localStorage.setItem('scout_token', res.token)
                  localStorage.setItem('login_type', res.user.login_type)
                  localStorage.setItem('startup_account', res.user.startup_account)
                  window.open('/scout/invite', '_blank')
                } else {
                  if (res.error === 'user is paused') {
                    window.open('/suspend', '_blank')
                  }
                }
              })
              .catch(err => {
                if (err?.error === 'user is paused') {
                  window.open('/suspend', '_blank')
                }
              })
          }}
        >
          <ScoutDashboardIcon />
          Scout Dashboard
        </div>
        <div className="itemPopup" onClick={() => onItemClick('/investor/settings/banking')}>
          <SettingsIcon />
          Settings
        </div>
        <div
          className="itemPopup"
          onClick={async event => {
            event.preventDefault()
            if (logoutLoader) return
            setIsLoggingOut(true)
            setLogoutLoader(true)
            const success = await fetchInvestorUserLogout()
            if (success) {
              localStorage.removeItem('investor_token')
              setLogoutLoader(false)
              history.replace('/investor/login')
            } else {
              setLogoutLoader(false)
            }
          }}
        >
          <LogoutIcon />
          Logout
        </div>
        {localStorage.getItem('startup_account') === true ||
        localStorage.getItem('startup_account') === 'true' ? (
          <div
            className="itemPopup signupStartupCon"
            onClick={() => {
              portalRedirection('investor', 'startup')
                .then(res => {
                  if (res.result) {
                    localStorage.setItem('startup_token', res.token)
                    localStorage.setItem('investor_account', res.user.investor_account)
                    if (['tracking', 'rejected', 'pending'].includes(res?.user?.status?.status)) {
                      window.open('/startup/thankyou', '_blank')
                    } else if (res?.user?.status?.status === 'incomplete') {
                      window.open(`/startup/onboarding/step-${res?.user?.onboarding_step + 1}`, '_blank')
                    } else {
                      window.open('/startup/approve/dashboard/status', '_blank')
                    }
                  } else {
                    if (res.error === 'user is paused') {
                      window.open('/suspend', '_blank')
                    }
                  }
                })
                .catch(err => {
                  if (err?.error === 'user is paused') {
                    window.open('/suspend', '_blank')
                  }
                })
            }}
          >
            <span className="investor-text">
              <GroupAffiliationIcon />
              Switch to Your Startup
            </span>
          </div>
        ) : (
          <div
            className="itemPopup signupStartupCon"
            onClick={() => {
              window.open('/startup/signup')
            }}
          >
            <span className="investor-text">
              <GroupAffiliationIcon />
              Sign Up Your Startup
            </span>
          </div>
        )}
      </div>
    )
  }

  // render the karma popover
  const renderKarmaContent = () => {
    return (
      <div className="profilePopupCon karmaPopupCon">
        <div className="mainPopup">
          <div className="headerSection">
            <div className="youKarmaPoint">Your Karma Points</div>
            <span style={{ marginRight: 10 }}>
              <KarmaStarIcon />
            </span>
            <div className="karmaTextContent">{user?.karma_points}</div>
          </div>
          <Divider />
          <div className="whatArePoints">What are karma points?</div>
          <div className="normalContent">
            Karma points are about how much good you have brought to our community. To return the favor, we
            invite individuals with more karma points to our deals earlier than those with less points. Our
            best deals go fast and this can make the whole difference whether you get a chance to participate!{' '}
          </div>
          <Divider />
          <div className="whatArePoints">How do you earn karma points?</div>
          <div className="karmaPointsContainer">
            <span style={{ marginRight: 10 }}>
              <KarmaStarIcon />
            </span>
            <div className="startupKarmaCon">When you invest in a startup, you earn 5 karma points!</div>
          </div>
          <div className="karmaPointsContainer">
            <span style={{ marginRight: 10 }}>
              <KarmaStarIcon />
            </span>
            <div className="startupKarmaCon">
              If you provide feedback when you pass on a startup, you earn 3 karma points!
            </div>
          </div>
          {/* <div className="karmaPointsContainer">
            <span style={{ marginRight: 10 }}>
              <KarmaStarIcon />
            </span>
            <div className="startupKarmaCon">
              If you explain why you're investing in a startup, you earn 3 karma points!
            </div>
          </div> */}
        </div>
      </div>
    )
  }

  // render the notification popover
  const renderNotificationContent = () => {
    return (
      <div className="notificationPopupCon">
        {notificationData?.length ? (
          <>
            <div className="headerNotificationCon">
              <div className="notificationText">Notification</div>
              <div className="clearText grow" onClick={onClearNotify}>
                Clear all
              </div>
            </div>
            <div className="mainContentNotification">
              {notificationData.map((item, key) => (
                <NotificationItem item={item} />
              ))}
            </div>
            <div className="viewAllText" onClick={() => history.push('/investor/notifications')}>
              <span className="grow">View All</span>
            </div>
          </>
        ) : (
          <div>
            <div className="headerNotificationCon">
              <div className="notificationText">Notification</div>
              <div className="clearText grow" onClick={() => history.push('/investor/notifications')}>
                View all
              </div>
            </div>
            {loader ? (
              <div className="notificationNotFoundCon">
                <Spin />
              </div>
            ) : (
              <div className="notificationNotFoundCon">
                <NotificationNotFoundIcon />
                <div className="notifyNotFoundText">No new notifications</div>
              </div>
            )}
          </div>
        )}
      </div>
    )
  }

  function getInvestorRedirectPath(user, normalLinkRoute) {
    if (user?.direct_approve && user?.direct_approve_deal_action_taken === false) {
      return { pathname: '/investor/profile-complete', state: { backBtnEnabled: 'enabled' } }
    }

    if (user?.direct_approve && user?.direct_approve_deal_action_taken) {
      return {
        pathname: user?.onboarding_complete ? normalLinkRoute : '/investor/profile-complete',
        state: { backBtnEnabled: 'enabled' },
      }
    }

    return { pathname: normalLinkRoute, state: { backBtnEnabled: 'enabled' } }
  }

  const handleAvatarClick = e => {
    const redirectPath = getInvestorRedirectPath(user, '')

    if (redirectPath.pathname === '/investor/profile-complete') {
      history.push(redirectPath, { backBtnEnabled: 'enabled' })
    } else {
      setOpen(true) // open Popover popup
    }
  }

  return (
    <>
      {logoutLoader && (
        <div
          style={{
            position: 'absolute',
            zIndex: 1200,
            display: 'flex',
            width: '100%',
            height: '100vh',
            alignItems: 'center',
            justifyContent: 'center',
            opacity: 1,
            background: 'white',
          }}
        >
          <Spin />
        </div>
      )}
      <div className="investorHeaderContainer sticky-top" style={{ zIndex: 1000 }}>
        <div className="toolbar sticky-top w-100">
          <div className="header m-0">
            <Navbar expand="lg" className="w-100 ">
              <Container className="headerTop" fluid style={{ height: 72 }}>
                <Navbar.Brand className="left">
                  <NavLink
                    style={{ textDecoration: 'none' }}
                    to={getInvestorRedirectPath(user, '/investor/deals')}
                  >
                    <div className="logo" id="home-logo">
                      <img
                        fetchPriority="high"
                        src={logoExitFund}
                        className="logoImg"
                        alt="logo"
                        width="275"
                        height="45"
                        style={{ height: '45px', width: 'auto' }}
                      />
                      <img
                        fetchPriority="high"
                        src={logo}
                        className="logoMobileImg"
                        alt="Logo - Exitfund"
                        width="75"
                        height="45"
                        style={{ height: '45px', width: 'auto' }}
                      />
                    </div>
                  </NavLink>
                </Navbar.Brand>
                <Navbar
                  id="basic-navbar-nav"
                  className=" d-md-flex d-sm-none justify-content-center navbarMobile"
                >
                  <div className="d-flex justify-content-center">
                    <Nav className="text-dark px-2" style={{ marginRight: 0 }}>
                      <Link
                        to={getInvestorRedirectPath(user, '/investor/deals')}
                        style={{ padding: '0 20px' }}
                        className={document.location.pathname.includes('investor/deals') && 'active'}
                      >
                        Deals
                      </Link>
                    </Nav>
                    <Nav className="text-dark px-2" style={{ marginRight: 0 }}>
                      <Link
                        to={getInvestorRedirectPath(user, '/investor/history-invested')}
                        style={{ padding: '0 20px' }}
                        className={
                          (document.location.pathname.includes('investor/history-invested') ||
                            document.location.pathname.includes('investor/history-passed')) &&
                          'active'
                        }
                      >
                        History
                      </Link>
                    </Nav>
                  </div>
                </Navbar>
                <div className="d-flex align-items-center mr-3 r-header">
                  <div className="invite-code-wrapi mr-2">
                    <span>{user?.personal_invite_code}</span>
                    <CopyToClipboard
                      text={user?.personal_invite_code}
                      onCopy={() => message.success('Copied to clipboard')}
                    >
                      <img role="button" className="ml-3" src={copyClipboard} alt="" />
                    </CopyToClipboard>
                  </div>
                  <div style={{ position: 'relative' }}>
                    <Popover
                      placement="bottomRight"
                      content={renderKarmaContent()}
                      trigger="click"
                      visible={openKarma}
                      overlayClassName={'popover-karma'}
                      onVisibleChange={e => setOpenKarma(e)}
                      overlayStyle={{ position: 'fixed' }}
                    >
                      <div className="karmaButton">
                        <KarmaStarIcon />
                        <span className="karmaTextCon">
                          {Math.max(user?.karma_points, investorKarmaPoints)?.toString().padStart(2, '0')}
                        </span>
                      </div>
                    </Popover>
                  </div>

                  <div style={{ position: 'relative' }}>
                    <Popover
                      placement="bottomRight"
                      content={renderNotificationContent()}
                      trigger="click"
                      visible={openNotification}
                      overlayClassName={'investor-notification-popup'}
                      onVisibleChange={e => setOpenNotification(e)}
                      overlayStyle={{ position: 'fixed' }}
                      align={{
                        offset: [5, 8],
                      }}
                    >
                      {count ? (
                        <Badge count={count}>
                          <span style={{ cursor: 'pointer' }}>
                            <NotificationIcon />
                          </span>
                        </Badge>
                      ) : (
                        <span style={{ cursor: 'pointer' }}>
                          <NotificationIcon />
                        </span>
                      )}
                    </Popover>
                  </div>
                  <div style={{ position: 'relative' }}>
                    <Popover
                      placement="bottomRight"
                      content={renderProfileContent()}
                      trigger="click"
                      visible={open}
                      overlayClassName={'popover-profile'}
                      onVisibleChange={e => setOpen(e)}
                      overlayStyle={{ position: 'fixed' }}
                    >
                      <Avatar
                        size={40}
                        className="profileAvatar ml-3 mr-3"
                        src={user?.profile_pic_link}
                        onClick={handleAvatarClick}
                      >
                        {user?.first_name.charAt(0)}
                      </Avatar>
                    </Popover>
                  </div>
                </div>
              </Container>
            </Navbar>
          </div>
        </div>
      </div>
    </>
  )
}

const mapStateToProps = state => ({
  token: state.auth.token,
  user: state.auth.user,
  investorKarmaPoints: state.investorflowControl.investorKarmaPoints,
})

const mapDispatchToProps = dispatch => ({
  getNotificationDropdownData: data => {
    return dispatch(getNotificationDropdownData(data))
  },
  portalRedirection: (url, data) => {
    return dispatch(portalRedirection(url, data))
  },
  getNotificationData: () => {
    return dispatch(getNotificationData())
  },
  fetchInvestorKarmaPoints: () => {
    return dispatch(fetchInvestorKarmaPoints())
  },
  fetchInvestorUserLogout: () => {
    return dispatch(fetchInvestorUserLogout())
  },
  clearInvestorNotification: () => {
    return dispatch(clearInvestorNotification())
  },
  logoutLocalInvestorUser: () => {
    return dispatch(logoutLocalInvestorUser())
  },
  updateLocalStartupUser: changedProperties => {
    dispatch(updateLocalStartupUser(changedProperties))
  },
})

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(InvestorHeader))
